{#if activeFaq === true }
<div  class="faq" aria-expanded={hidden}>
    <div style="color:{bgcolor}" class="chatwith-question" on:click={() => toggle()}>
        <svg width="12" height="12" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 511.98 511.98" style="enable-background:new 0 0 511.98 511.98;" xml:space="preserve">
            <polygon style="fill:{bgcolor};" points="18.468,467.029 255.99,55.638 493.497,467.029 "/>
        </svg>
        {faq.question}
    </div>
        {#if hidden === false || allowToggle===false}

            <div in:fade out:slide  class="chatwith-answer">
                {@html faq.answer}
            </div>
        {/if}
</div>
{/if}

<script>
    import { slide, fade } from 'svelte/transition';

    export let faq;
    export let bgcolor;
    export let activeFaq;
    export let allowToggle;

    let hidden=true

    const toggle = () => {
        if (allowToggle===true){
            hidden = !hidden
        }
    }


</script>

<style>
    .faq{
        padding-top:10px
    }
    .chatwith-question {
        font-weight: bold;
        font-size: 14px;
        cursor:pointer;
    }
    .chatwith-answer {
        max-width: 240px;
        font-size: 14px !important;
        padding-left:20px;
    }
    .chatwith-answer a {
        text-decoration: underline;
        color: #999999;
    }
    .chatwith-answer p{
        margin: 0;
    }

    :global(.chatwith-answer p){
        margin-top:5px;
        margin-bottom: 5px;    
    }

    svg { 
        transition: transform 0.2s ease-in;
        transform: translate(0px, 1px) rotate(0.25turn);
	}

    [aria-expanded=false] svg { transform:  translate(0px, 1px) rotate(0.5turn); }
</style>
